import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Typography,
  Paper,
  Divider,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useLazyGetAgentAccountDetailsQuery } from "../../../redux/api/salary";
import AgentsEditor from "./EditAgents";
import { selectCurrentagency } from "../../../redux/features/authSlice";
import { useSelector } from "react-redux";

const AgentAccountDetails = () => {
  const currentAgency = useSelector(selectCurrentagency);
  const agencyId = currentAgency.agencyid;

  // Default: current month/year
  const [selectedDate, setSelectedDate] = useState(dayjs());

  const [getAgentAccountDetails, { data, isFetching, error }] =
    useLazyGetAgentAccountDetailsQuery();

  const handleFetch = () => {
    if (!selectedDate) return;
    const month = selectedDate.month() + 1; // dayjs is 0-indexed
    const year = selectedDate.year();
    getAgentAccountDetails({ agencyId, month, year });
  };

  // Fetch immediately on load for current month/year
  useEffect(() => {
    handleFetch();
  }, []);

  return (
    <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 3 }}>
      <Typography variant="h6" gutterBottom fontWeight="bold">
        Agent Account Details
      </Typography>
      <Divider sx={{ mb: 3 }} />

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6} md={4}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Select Month & Year"
              views={["year", "month"]}
              value={selectedDate}
              onChange={(newValue) => setSelectedDate(newValue)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: "small",
                },
              }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={12} sm="auto">
          <Button
            variant="contained"
            color="primary"
            onClick={handleFetch}
            disabled={isFetching}
            sx={{ mt: { xs: 2, sm: 0 } }}
          >
            {isFetching ? <CircularProgress size={22} /> : "Filter"}
          </Button>
        </Grid>
      </Grid>

      {/* Results Section */}
      <Box sx={{ mt: 3 }}>
        {error && (
          <Typography color="error" sx={{ mt: 2 }}>
            Failed to fetch Agent Account details 
          </Typography>
        )}

        {!error && !isFetching && !data && (
          <Typography color="text.secondary" sx={{ mt: 2 }}>
            Select a month and year, then click "Fetch Details" to load data.
          </Typography>
        )}

        {data && <AgentsEditor agents={data} />}
      </Box>
    </Paper>
  );
};

export default AgentAccountDetails;
